import {Component, OnInit} from '@angular/core';
import {MassSubject} from '../../model';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {ActivatedRoute, Router} from "@angular/router";
import {Utils} from "@amlCore/utils";
import {RegistriesService} from "../../service";
import {TableService, VisitedService} from "@amlCore/services";


@Component({
  selector: 'app-registry-mass-lead-subject',
  templateUrl: './massLeadSubject.component.html'
})
export class MassLeadSubjectComponent extends TableReactiveUrlController implements OnInit {

  isShowVisited = false;

  constructor(private regSrv: RegistriesService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'firstName', dir: 'ASC'});
  }

  public id: string; // уникальный идентификатор
  public isAll = false; // поиск по всем перечням
  public massLeadSubjectList: Array<MassSubject> = [];
  public goBack = Utils.goBack;

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id;
    if (this.id === undefined) {
      this.isAll = true;
    }
    this.activatedRoute.queryParams.subscribe(params => {
      this.loadList(this.syncParams(params));
    });
  }

  public onPageChange(params) {
    const filter = this.getParams({...params, ...this.filter});
    filter['isAll'] = this.isAll;
    this.navigate(filter);
  }

  // @ovveride
  public onSearch() {
    const queryParams = this.getSearchPage(this.filter);
    this.onPageChange(queryParams);
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  private loadList(params?: any) {
    const queryParams = this.getParams(params);
    this.regSrv.getMassLeadSubjectList(queryParams, this.id).subscribe(data => {
      this.massLeadSubjectList = data.content;
      this.total = data.totalElements;
    });
  }

}
